import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatabaseProvider } from '@paella-front/ngx-database';
import { BehaviorSubject, Observable } from 'rxjs';

const LANG = 'LANG';
const URL_TOKEN = 'URL_TOKEN';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  URL_TOKEN: string;
  private readonly _urlToken$: BehaviorSubject<string> = new BehaviorSubject(null);
  private readonly $database: ReturnType<DatabaseProvider['get']>;

  constructor(
    private translate: TranslateService,
    $$db: DatabaseProvider
  ) {
    this.$database = $$db.default;
    this.loadUrlToken();
  }

  async setLang(lang: 'es' | 'en'): Promise<void> {
    this.translate.use(lang);
    await (this.$database as any).set(LANG, lang);
  }

  async getLang(): Promise<any> {
    return (await (this.$database as any).get(LANG))
      ? await (this.$database as any).get(LANG)
      : this.translate.getBrowserLang();
  }

  async setUrlToken(token: string): Promise<void> {
    await (this.$database as any).set(URL_TOKEN, token);
    this.URL_TOKEN = token;
    this._urlToken$.next(token);
  }

  get urlToken$(): Observable<string | null> {
    return this._urlToken$.asObservable();
  }

  async loadUrlToken(): Promise<string | null> {
    const urlToken = await (this.$database as any).get(URL_TOKEN);
    this._urlToken$.next(urlToken);
    return urlToken;
  }
}
